import apiClient from './apiClient';

// ============================================================
// Types -- matching backend Go models
// ============================================================

export interface F9441 {
  f9441_01: string;   // 調整單號
  f9441_02: number;   // 序號
  f9441_10: string;   // 員工代號
  f9441_11: string;   // 薪資代號
  f9441_11a: string;  // 薪資名稱
  f9441_12: number;   // 調整後金額
  f9441_20: string;   // 月份
  f9441_21: number;   // 原有金額
}

export interface F9440 {
  f9440_01: string;        // 調整單號 (PK)
  f9440_10: string;        // 員工代號
  f9440_20: string;        // 開始異動月份 (YYYYMM)
  f9440_21: number;        // 勞保薪資
  f9440_23: number;        // 健保薪資
  f9440_41: string;        // 部門代號
  f9440_91: string;        // 建立/修改人員
  f9440_92: string | null; // 修改日期
  f9440_93: string;        // 修改時間
  details?: F9441[];       // 明細
}

export interface DetailRequest {
  f9441_02: number;   // 序號
  f9441_11: string;   // 薪資代號
  f9441_11a: string;  // 薪資名稱
  f9441_12: number;   // 調整後金額
  f9441_21: number;   // 原有金額
}

export interface CreateRequest {
  f9440_10: string;        // 員工代號
  f9440_20: string;        // 開始異動月份
  f9440_21: number;        // 勞保薪資
  f9440_23: number;        // 健保薪資
  f9440_41: string;        // 部門代號
  details: DetailRequest[];
}

export interface UpdateRequest {
  f9440_20: string;        // 開始異動月份
  f9440_21: number;        // 勞保薪資
  f9440_23: number;        // 健保薪資
  f9440_41: string;        // 部門代號
  details: DetailRequest[];
}

export interface ListResponse {
  data: F9440[];
  total: number;
  page: number;
  size: number;
}

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const salaryAdjustApi = {
  async list(page = 1, size = 100, keyword?: string): Promise<ListResponse> {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    const res = await apiClient.get('/api/salary-adjust', { params });
    return res.data;
  },

  async get(id: string): Promise<F9440> {
    const res = await apiClient.get(`/api/salary-adjust/${encodeURIComponent(id)}`);
    return res.data;
  },

  async create(data: CreateRequest): Promise<F9440> {
    const res = await apiClient.post('/api/salary-adjust', data);
    return res.data;
  },

  async update(id: string, data: UpdateRequest): Promise<F9440> {
    const res = await apiClient.put(`/api/salary-adjust/${encodeURIComponent(id)}`, data);
    return res.data;
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(`/api/salary-adjust/${encodeURIComponent(id)}`);
  },
};
